import { accountsTypes } from '../accounts';

export function replaceRawASCII(string) {
  return string?.replace(/&#(.*?);/g, (code) => {
    let num = code.replace(/&#|x|;/g, '');
    num = Number.parseInt(num, code[2] === 'x' ? 16 : 10);
    return String.fromCharCode(num);
  });
}

export function getNewAccountFields(account, linkToAccountId, accountsById) {
  if (linkToAccountId && linkToAccountId !== '0') {
    const linkToAccount = accountsById.get(linkToAccountId);
    return {
      name: linkToAccount.name,
      type: accountsTypes.getAccountTypeNodeByQcsType(linkToAccount.type, linkToAccount.subType),
      usageId: linkToAccount.businessId || (linkToAccount.usageType === 'BUSINESS' ? 'BUSINESS' : 'PERSONAL'),
      linkToId: linkToAccountId,
    };
  }
  return {
    name: account.discoveredAccount.name,
    type: accountsTypes.getAccountTypeNodeByQcsType(account.discoveredAccount.type, account.discoveredAccount.subType),
    usageId: account.discoveredAccount.businessId ?? 'PERSONAL',
    linkToId: '0',
  };
}

//we use a diff account structure and flow for mint import
export function getNewAccountFieldsMint(account, linkToAccountId, accountsById) {
  if (linkToAccountId && linkToAccountId !== '0') {
    const linkToAccount = accountsById.get(linkToAccountId);
    return {
      name: linkToAccount.name,
      type: accountsTypes.getAccountTypeNodeByQcsType(linkToAccount.type, linkToAccount.subType),
      usageId: linkToAccount.businessId || (linkToAccount.usageType === 'BUSINESS' ? 'BUSINESS' : 'PERSONAL'),
      linkToId: linkToAccountId,
    };
  }
  return {
    name: account.accountName,
    type: undefined,
    usageId: 'PERSONAL',
    linkToId: '0',
  };
}
